import { useStore } from 'zustand';
var useItemAddedModalStore = function useItemAddedModalStore(select) {
  return useStore(window.NikeShop.__INTERNAL_USE__.stores.itemAddedModal.store, select);
};
export default useItemAddedModalStore;